import {ICampaignStatusEnum} from '../../campaigns/interfaces/ICampaigns';
import OrderLists from '../components/list';

const OrderOnAir = () => {
  return <OrderLists status={ICampaignStatusEnum.ON_AIR} />;
};

export default OrderOnAir;
